<template>
    <div class="wineguide-container">
        <div class="itips-head">
            <div class="container">
                <div class="inner-page-title">{{ $t("home-top4") }}</div>
                <div class="inenr-page-breadcrumb">
                    <div class="inner-page-bread-line"></div>
                </div>
            </div>
        </div>
        <div class="container">
            <div class="wine-guide-body">
                <div class="wine-guide-left hide-mobile">
                    <div class="wine-guide-left-title">
                        <nuxt-link class="wine-guide-back" :to="localePath('/wine-guide/usa')"></nuxt-link>
                        Producers
                    </div>
                    <nuxt-link class="wine-guide-country"
                               :to="localePath('/wine-guide/usa/napa/abreu-vineyards')">Abreu Vineyards
                    </nuxt-link>
                    <nuxt-link class="wine-guide-country"
                               :to="localePath('/wine-guide/usa/napa/caymus-vineyards')">Caymus vineyards
                    </nuxt-link>
                    <nuxt-link class="wine-guide-country"
                               :to="localePath('/wine-guide/usa/napa/christian-moueix-dominus')">Christian Moueix -
                        Dominus
                    </nuxt-link>
                    <nuxt-link class="wine-guide-country"
                               :to="localePath('/wine-guide/usa/napa/colgin-cellars')">Colgin Cellars
                    </nuxt-link>
                    <nuxt-link class="wine-guide-country"
                               :to="localePath('/wine-guide/usa/napa/harlan-estates')">Harlan Estates
                    </nuxt-link>
                    <nuxt-link class="wine-guide-country"
                               :to="localePath('/wine-guide/usa/napa/kapcsandy-winery')">Kapcsandy Winery
                    </nuxt-link>
                    <nuxt-link class="wine-guide-country"
                               :to="localePath('/wine-guide/usa/napa/opus-one')">Opus One
                    </nuxt-link>
                    <nuxt-link class="wine-guide-country"
                               :to="localePath('/wine-guide/usa/napa/robert-mondovi-vineyards')">Robert Mondovi
                        Vineyards
                    </nuxt-link>
                    <nuxt-link class="wine-guide-country"
                               :to="localePath('/wine-guide/usa/napa/scarecrow-wines')">Scarecrow Wines
                    </nuxt-link>
                    <nuxt-link class="wine-guide-country"
                               :to="localePath('/wine-guide/usa/napa/schrader-cellars')">Schrader Cellars
                    </nuxt-link>
                    <nuxt-link class="wine-guide-country"
                               :to="localePath('/wine-guide/usa/napa/screaming-eagle')">Screaming Eagle
                    </nuxt-link>
                </div>
                <div class="show-mobile">
                    <div class="wine-guide-left-title">
                        <nuxt-link class="wine-guide-back" :to="localePath('/wine-guide/usa')"></nuxt-link>
                        Producers
                    </div>
                    <v-select
                        :items="items"
                        v-model="select"
                        label="Please choose"
                        single-line
                        item-text="report"
                        item-value="src"
                        return-object
                        class="show-mobile show-mobile-select"
                        v-on:change="changeRoute"
                    ></v-select>
                </div>
                <div v-if="$i18n.locale === 'it'" class="wine-guide-right">
                    <div class="howto-title">Napa</div>
                    <div class="howto-separator"></div>
                    <div class="howto-text">
                        Chiaramente il re della scena vinicola californiana, Napa è la scelta della gente quando si tratta di
                        Cabernet Sauvignon. Altre varietà includono Merlot, Chardonnay Zinfandel, Syrah, Cabernet Franc,
                        Petite Sirah, Sangiovese, Nebbiolo, Barbera, Dolcetto, Charbono per i vini rossi e Chardonnay,
                        Sauvignon Blanc, Pinot Grigio, Moscato, Viognier per le uve bianche ma in generale, se si dice
                        Napa, probabilmente intendi Cabernet Sauvignon.
                        <br><br>
                        La storia di Napa iniziò nel 1840 quando i pionieri George Calvert Yount, John Patchett e Hamilton
                        Walker Crabb ha introdotto nella zona le prime uve di vitis vinifera. La notizia si diffuse e nel 1861
                        Charles Krug aveva aperto una cantina, generando grande interesse (per non parlare di posti di lavoro) nella zona.
                        Alla fine del XIX secolo, Napa contava oltre 140 aziende vinicole, tra cui la famosissima Inglenook
                        vigna (fondata nel 1879). Tuttavia, non avendo il savoir-faire né l'attrezzatura del
                        Europei, l'inizio del XX secolo ha visto un'inversione di tendenza: un eccesso di uva che nessuno voleva,
                        fillossera che nessuno sapeva come combattere e il proibizionismo significava che solo il 10% dell'originale
                        le cantine furono lasciate, operando esclusivamente per scopi sacramentali del vino. Il recupero è stato lento; IL
                        La famiglia Mondovì acquistò l'ex cantina Krug, John Daniel Jr. fece risorgere Inglenook e,
                        rendendosi conto che erano molto più forti insieme che da soli, le sette figure chiave della Valle
                        ha creato i Napa Valley Vintners (che ora conta 550 membri). Lo status di Napa come mondo
                        leader è stato stabilito quando i giudici francesi hanno premiato un vino Napa – un Stag’s Leap del 1973 – al
                        Judgment de Paris nel 1976, battendo di colpo il Bordeaux. Da quel momento in poi, l'unico modo era salire
                        per il buon vino USA.
                    </div>
                </div>
                <div v-else-if="$i18n.locale === 'de'" class="wine-guide-right">
                    <div class="howto-title">Napa</div>
                    <div class="howto-separator"></div>
                    <div class="howto-text">
                        Napa ist eindeutig der König der kalifornischen Weinszene und die erste Wahl, wenn es darum geht
                        Cabernet Sauvignon. Weitere Sorten sind Merlot, Chardonnay Zinfandel, Syrah, Cabernet Franc,
                        Petite Sirah, Sangiovese, Nebbiolo, Barbera, Dolcetto, Charbono für Rotweine und Chardonnay,
                        Sauvignon Blanc, Pinot Grigio, Muscat, Viognier für weiße Trauben, aber im Allgemeinen, wenn Sie sagen
                        Napa, du meinst wahrscheinlich Cabernet Sauvignon.
                        <br><br>
                        Die Geschichte von Napa begann im Jahr 1840 mit den Pionieren George Calvert Yount, John Patchett und Hamilton
                        Walker Crabb brachte die ersten Vitis vinifera-Trauben in die Gegend. Die Nachricht verbreitete sich bis 1861
                        Charles Krug hatte ein Weingut eröffnet und damit großes Interesse (ganz zu schweigen von Arbeitsplätzen) in der Gegend geweckt.
                        Bis zum Ende des 19. Jahrhunderts gab es in Napa über 140 Weingüter, darunter das sehr berühmte Inglenook
                        Weinberg (gegründet 1879). Allerdings verfügt er weder über das Know-how noch über die Ausrüstung des
                        Für die Europäer erlebte das frühe 20. Jahrhundert eine Wende: eine Überschwemmung von Weintrauben, die niemand wollte,
                        Reblaus, die niemand zu bekämpfen wusste, und das Verbot führten dazu, dass nur 10 % des Originals ausfielen
                        Die Weingüter blieben übrig und dienten ausschließlich dem sakramentalen Weinanbau. Die Erholung verlief langsam; Die
                        Die Familie Mondovi kaufte das ehemalige Krug-Weingut, John Daniel Jr. ließ Inglenook wieder auferstehen und
                        Sie erkannten, dass sie gemeinsam viel stärker waren als allein, die sieben Schlüsselfiguren des Tals
                        gründete die Napa Valley Vintners (die mittlerweile 550 Mitglieder hat). Napas Status als Welt
                        Leader wurde gegründet, als französische Richter einen Napa-Wein – einen Stag’s Leap von 1973 – im Jahr 1973 auszeichneten
                        Judgment de Paris im Jahr 1976, mit großem Vorsprung vor Bordeaux. Von da an ging es nur noch nach oben
                        für guten Wein aus den USA.
                    </div>
                </div>
                <div v-else-if="$i18n.locale === 'fr'" class="wine-guide-right">
                    <div class="howto-title">Napa</div>
                    <div class="howto-separator"></div>
                    <div class="howto-text">
                        Clairement le roi de la scène viticole californienne, Napa est le choix des gens quand il s'agit de
                        Cabernet Sauvignon. D'autres variétés comprennent le Merlot, le Chardonnay Zinfandel, la Syrah, le Cabernet Franc,
                        Petite Sirah, Sangiovese, Nebbiolo, Barbera, Dolcetto, Charbono pour les vins rouges et Chardonnay,
                        Sauvignon Blanc, Pinot Grigio, Muscat, Viognier pour les cépages blancs mais en général, si vous dites
                        Napa, vous voulez probablement dire Cabernet Sauvignon.
                        <br><br>
                        L'histoire de Napa a commencé en 1840 lorsque les pionniers George Calvert Yount, John Patchett et Hamilton
                        Walker Crabb a introduit les premiers raisins vitis vinifera dans la région. Les nouvelles se sont répandues et en 1861
                        Charles Krug avait ouvert une cave, générant un grand intérêt (sans parler des emplois) dans la région.
                        À la fin du 19e siècle, Napa comptait plus de 140 établissements vinicoles, dont le très célèbre Inglenook
                        vignoble (créé en 1879). Cependant, n'ayant pas le savoir-faire ni l'équipement des
                        Européens, le début du 20ème siècle a vu un retournement de situation : une surabondance de raisins dont personne ne voulait,
                        phylloxera que personne ne savait combattre et l'interdiction signifiait que seulement 10% de la
                        les établissements vinicoles ont été laissés, fonctionnant uniquement à des fins de vin sacramentel. La récupération a été lente; le
                        La famille Mondovi a acheté l'ancienne cave Krug, John Daniel Jr. a ressuscité Inglenook et,
                        se rendant compte qu'ils étaient bien plus forts ensemble que seuls, les sept figures incontournables de la Vallée
                        créé les Napa Valley Vintners (qui compte aujourd'hui 550 membres). Le statut de Napa en tant que monde
                        leader a été établi lorsque les juges français ont décerné un vin Napa - un Stag's Leap 1973 - au
                        Jugement de Paris en 1976, battant Bordeaux de loin. Dès lors, le seul moyen était de monter
                        pour le bon vin américain.
                    </div>
                </div>
                <div v-else class="wine-guide-right">
                    <div class="howto-title">Napa</div>
                    <div class="howto-separator"></div>
                    <div class="howto-text">
                        Clearly the king of the Californian wine scene, Napa is the people choice when it comes to
                        Cabernet Sauvignon. Other varieties include Merlot, Chardonnay Zinfandel, Syrah, Cabernet Franc,
                        Petite Sirah, Sangiovese, Nebbiolo, Barbera, Dolcetto, Charbono for red wines and Chardonnay,
                        Sauvignon Blanc, Pinot Grigio, Muscat, Viognier for white grapes but in general, if you say
                        Napa, you probably mean Cabernet Sauvignon.
                        <br><br>
                        Napa’s history began in 1840 when pioneers George Calvert Yount, John Patchett and Hamilton
                        Walker Crabb introduced the first vitis vinifera grapes to the area. News spread and by 1861
                        Charles Krug had opened a winery, generating great interest (not to mention jobs) in the area.
                        By the late 19th century, Napa had over 140 wineries, including the very famous Inglenook
                        vineyard (founded in 1879). However, not having the savoir-faire nor the equipment of the
                        Europeans, the early 20 th century saw a turn in tides: a glut of grapes that nobody wanted,
                        phylloxera that nobody knew how to combat and prohibition meant that just 10% of the original
                        wineries were left, operating solely for sacramental wine purposes. Recovery was slow; the
                        Mondovi family purchased the ex-Krug winery, John Daniel Jr. resurrected Inglenook and,
                        realising that they were much stronger together than alone, the seven key figures of the Valley
                        created the Napa Valley Vintners (which now stands at 550 members). Napa’s status as a world
                        leader was established when French judges awarded a Napa wine – a 1973 Stag’s Leap – at the
                        Judgement de Paris in 1976, beating Bordeaux by a long shot. From then on, the only way was up
                        for USA fine wine.
                    </div>
                </div>
            </div>
        </div>

    </div>
</template>

<script>
export default {
    name: "Napa",
    head: {
        title: 'Napa fine wine | Vindome Wine Guide',
        meta: [
            {
                hid: 'description',
                name: 'description',
                content: 'Discover the rich, diverse flavors of the Napa wine region. Visit top wineries and taste world-renowned wines made from premium Napa grapes.'
            }
        ],
        bodyAttrs: {
            class: 'wine-guide inner-page'
        }
    },
    data() {
        return {
            select: {report: 'Please choose', src: '#'},
            items: [
                {report: 'Abreu Vineyards', src: '/wine-guide/usa/napa/abreu-vineyards'},
                {report: 'Caymus vineyards', src: '/wine-guide/usa/napa/caymus-vineyards'},
                {report: 'Christian Moueix - Dominus', src: '/wine-guide/usa/napa/christian-moueix-dominus'},
                {report: 'Colgin Cellars', src: '/wine-guide/usa/napa/colgin-cellars'},
                {report: 'Harlan Estates', src: '/wine-guide/usa/napa/harlan-estates'},
                {report: 'Kapcsandy Winery', src: '/wine-guide/usa/napa/kapcsandy-winery'},
                {report: 'Opus One', src: '/wine-guide/usa/napa/opus-one'},
                {report: 'Robert Mondovi Vineyards', src: '/wine-guide/usa/napa/robert-mondovi-vineyards'},
                {report: 'Scarecrow Wines', src: '/wine-guide/usa/napa/scarecrow-wines'},
                {report: 'Schrader Cellars', src: '/wine-guide/usa/napa/schrader-cellars'},
                {report: 'Screaming Eagle', src: '/wine-guide/usa/napa/screaming-eagle'}
            ]
        }
    },
    methods: {
        changeRoute(a) {
                this.$router.push({path: this.localePath(a.src) });
            }
    }
}
</script>

<style scoped>
.container {
    max-width: 1170px;
    padding: 0;
    font-family: 'Poppins', sans-serif;
}

.wine-guide-body {
    padding-top: 35px;
}

.wine-guide-left {
    width: 300px;
    display: inline-block;
}

.wine-guide-right {
    display: inline-block;
    width: calc(100% - 305px);
    vertical-align: top;
}

.wine-guide-left-title {
    font-weight: 600;
    color: #024E7B;
    font-size: 18px;
    height: 57px;
    line-height: 57px;
}

.wine-guide-country {
    display: block;
    height: 57px;
    line-height: 57px;
    text-decoration: none;
    color: #000;
    font-size: 16px;
    padding-left: 30px;
    width: 260px;
    border-left: 3px solid transparent;
}

.wine-guide-country:hover {
    border-color: #024E7B;
    background: #E5EDF2;
}
</style>
